import { useContext, useEffect, useState } from "react";
import { Route as RouteDom } from "react-router-dom";
import queryString from "query-string";

import { QueryParamsContext } from "../context/QueryParamsContext";
import { findEmpresasV2 } from "../repositories/qerpapi/erp/prouser/v2/EmpresasRepository";

export default function Route({ path, component: Component }) {
  const {
    setQueryParams,
    queryParams,
    querySearch,
    setQuerySearch,
    setTempQueryParams,
  } = useContext(QueryParamsContext);

  const [lastParams, setLastParams] = useState("");
  const params = queryString.parse(window.location.search);

  useEffect(() => {
    if (!window.location || !window.location.search) return;

    if (window.location.search !== lastParams) {
      setLastParams(window.location.search);

      const getDataCompany = async (actualyQueryParams, params) => {
        try {
          if (params.empresa_cnpj) {
            sessionStorage.setItem("empresa_cnpj", params.empresa_cnpj);
          }
          const response = await findEmpresasV2(
            params.empresa_cnpj || sessionStorage.empresa_cnpj,
            params.empresa_id || sessionStorage.empresa_id
          );

          let newParams = params;
          if (response.success && response.data) {
            newParams = {
              ...newParams,
              ...response.data,
            };

            Object.keys(newParams).forEach((key) => {
              if (newParams[key] || newParams[key] === 0) {
                sessionStorage.setItem(key, newParams[key].toString());
                newParams[key] = newParams[key].toString();
              } else {
                sessionStorage.setItem(key, "");
                newParams[key] = "";
              }
            });

            setQueryParams({
              actualyQueryParams,
              ...response.data,
              ...sessionStorage,
              ...newParams,
            });

            setQuerySearch(true);
          }
        } catch (error) {
          console.error(error);
        }
      };

      var actualyQueryParams = queryParams;
      if (params?.clearPreviusQueryParams?.length > 0) {
        const clearPreviusQueryParams = params.clearPreviusQueryParams;

        if (typeof clearPreviusQueryParams === "string") {
          sessionStorage.setItem(clearPreviusQueryParams, "");
          actualyQueryParams[clearPreviusQueryParams] = "";
        } else {
          clearPreviusQueryParams.forEach((paramName) => {
            sessionStorage.setItem(paramName, "");
            actualyQueryParams[paramName] = "";
          });
        }

        delete params.clearPreviusQueryParams;
      }

      let tempParams = {};

      Object.keys(params).forEach((key) => {
        if ((key || "").startsWith("tempParam_")) {
          tempParams[key.replace("tempParam_", "")] = params[key];
          delete params[key];
        } else {
          sessionStorage.setItem(key, params[key]);
        }
      });

      setTempQueryParams(tempParams);

      setQueryParams({
        actualyQueryParams,
        ...sessionStorage,
        ...params,
      });

      if (!querySearch) {
        console.log("DEBUG => Efetuando Busca de Dados da Empresa");
        getDataCompany(actualyQueryParams, params);
      }
    }
    // eslint-disable-next-line
  }, [
    lastParams,
    setQueryParams,
    params.empresa_cnpj,
    setQuerySearch,
    params,
    querySearch,
  ]);

  return <RouteDom path={path} component={Component} />;
}
